<template>
  <!-- 学历统计 -->
  <div class="box fl">
    <div class="line">
      <el-divider></el-divider>
    </div>
    <div class="tu">
      <div
        style="width:100%;height:100%"
        class="chart-class"
        ref="university"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props:{
    educationList:"",
  },
  computed: {
    nameList(){
      return this.educationList.map(item=>item.name)
    }
  },
  data() {
    return {};
  },
  created(){
    this.educationList.forEach(item=>{
      item.value=item.nums
    })
  },
  mounted() {
    this.initCharts();
    //this.universityLsit();
  },
  methods: {
    initCharts() {
      let option = {
        color: ["#1890FF", "#F04864", "#FACC14", "#2FC25B"],
        grid: {
          left: "2%",
          top: "1%",
          bottom: 10,
          right: "1%",
          containLabel: true,
        },
        tooltip: {
          trigger: "item",
          confine: true,
          textStyle: {
            fontSize: 14,
          },
          formatter: "{b} : {c} ({d}%)",
        },
        //图片设置
        graphic: {
          elements: [
            {
              type: "image",
              z: 3,
              style: {
                width: 100,
                height: 100,
              },
              left: "center",
              top: "center",
              position: [100, 100],
            },
          ],
        },
        //中间固定的得分
        title: [
          {
            text: "学历统计",
            x: "50%",
            y: "0%",
            textAlign: "center",
            textStyle: {
              fontSize: "24",
              fontWeight: "700",
              color: "#555",
              textAlign: "center",
            },
          },
        ],
        legend: {
          x: "center",
          top: "17%",
          textStyle: {
            color: "rgba(0, 0, 0, 0.45)",
            fontSize: 13,
          },
          //原点
          icon: "circle",
          //修改icon图形大小
          itemHeight: 6,
          data: this.nameList,
        },
        calculable: true,
        series: [
          //最外面的圆环
          {
            type: "pie",
            radius: ["59.5%", "60%"],
            center: ["55%", "67%"],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            name: "",
            data: [
              {
                name: "",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#36cb8c",
                  },
                },
              },
            ],
          },
          //里面的内容圆环
          {
            stack: "a",
            type: "pie",
            radius: ["10%", "55%"],
            center: ["55%", "67%"],
            roseType: "area",
            zlevel: 10,
            //百分比 名称 显示
            label: {
              show: false,
              // normal: {
              //   formatter: "{d}%",
              //   borderWidth: 0,
              //   borderRadius: 4,
              //   padding: [0, -50],
              //   height: 40,
              //   fontSize: 12,
              //   align: "center",
              //   rich: {
              //     b: {
              //       fontSize: 13,
              //       lineHeight: 5,
              //       color: "#41B3DC",
              //     },
              //   },
              // },
            },
            //指引的线
            labelLine: {
              show: false,
              // normal: {
              //   show: true,
              //   length: 20,
              //   length2: 55,
              // },
              // emphasis: {
              //   show: false,
              // },
            },
            data: this.educationList,
          },
        ],
      };

      let myChart = this.$echarts.init(this.$refs.university);
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  .line {
    position: relative;
    top: 0px;
    left: 0px;
    .el-divider--horizontal {
      position: absolute;
      top: 61px;
      left: 0px;
    }
  }
  box-sizing: border-box;
  width: 278px;
  height: 282px;
  margin-bottom: 24px;
  margin-right: 24px;
  background: #fff;
  border-radius: 7px;
  padding: 20px 24px;
  .tu {
    width: 100%;
    height: 100%;
  }
}
</style>
